(function () {
  'use strict';

  function expandItem(item) {
    const body = item.querySelector('.section-science-accordion-media__body');
    if (!body || item.dataset.animating === 'true') return;

    item.dataset.animating = 'true';
    item.setAttribute('open', 'true');
    body.style.height = '0px';
    body.style.opacity = '';
    body.style.marginTop = '';

    requestAnimationFrame(() => {
      body.style.height = body.scrollHeight + 'px';
    });

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onEnd);
      body.style.height = 'auto';
      body.style.opacity = '';
      body.style.marginTop = '';
      delete item.dataset.animating;
    };

    body.addEventListener('transitionend', onEnd);
  }

  function collapseItem(item) {
    const body = item.querySelector('.section-science-accordion-media__body');
    if (!body || item.dataset.animating === 'true') return;

    item.dataset.animating = 'true';
    body.style.height = body.scrollHeight + 'px';
    body.style.opacity = '0';
    body.style.marginTop = '0';

    requestAnimationFrame(() => {
      body.style.height = '0px';
    });

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onEnd);
      item.removeAttribute('open');
      body.style.height = '';
      body.style.opacity = '';
      body.style.marginTop = '';
      delete item.dataset.animating;
    };

    body.addEventListener('transitionend', onEnd);
  }

  function initSection(section) {
    const items = Array.from(section.querySelectorAll('.section-science-accordion-media__item'));
    if (!items.length) return;

    const shouldOpenFirst = section.dataset.firstOpen !== 'false';
    if (shouldOpenFirst && !section.querySelector('.section-science-accordion-media__item[open]')) {
      items[0].setAttribute('open', 'true');
    }

    items.forEach((item) => {
      const summary = item.querySelector('.section-science-accordion-media__summary');
      const body = item.querySelector('.section-science-accordion-media__body');
      if (!summary || !body) return;

      body.style.height = item.hasAttribute('open') ? 'auto' : '0px';

      const onToggle = (event) => {
        event.preventDefault();
        if (item.dataset.animating === 'true') return;

        if (item.hasAttribute('open')) {
          collapseItem(item);
          return;
        }

        items.forEach((other) => {
          if (other !== item && other.hasAttribute('open')) {
            collapseItem(other);
          }
        });
        expandItem(item);
      };

      summary.addEventListener('click', onToggle);
      summary.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') onToggle(event);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-science-accordion]').forEach((section) => initSection(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    const section = event.target.querySelector('[data-science-accordion]');
    if (!section) return;
    initSection(section);
  });
})();
